import { isDeepEqual } from "@suse-o11y/is-deep-equal";
import { Slot } from "@suse-o11y/slot";
import { useMemo } from "@suse-o11y/use-memo";
import React from "react";
import type {
	DraggableProvidedDragHandleProps,
	DraggableProvidedDraggableProps,
	DraggableRubric,
	DraggableStateSnapshot,
	// biome-ignore lint/style/noRestrictedImports:  component usage
} from "react-beautiful-dnd";

import { DraggableContextProvider } from "./context/draggable";

export interface DraggableContentProps extends DraggableProvidedDraggableProps {
	snapshot: DraggableStateSnapshot;
	rubric: DraggableRubric;
	dragHandleProps: undefined | DraggableProvidedDragHandleProps;
	children: React.ReactElement;
}

export const DraggableContent = React.forwardRef<HTMLElement, DraggableContentProps>(
	({ snapshot, rubric: { mode, ...rubric }, dragHandleProps, style, ...props }, ref) => {
		const context = useMemo(
			() => ({
				dragHandleProps,
				value: { ...snapshot, ...rubric },
			}),
			// biome-ignore lint/correctness/useExhaustiveDependencies(rubric): can change on every render due to custom compare
			[snapshot, rubric, dragHandleProps],
			isDeepEqual,
		);

		return (
			<DraggableContextProvider value={context}>
				<Slot ref={ref} style={style as React.CSSProperties} {...props} />
			</DraggableContextProvider>
		);
	},
);
